import { Component, OnInit, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { FormGroup } from '@angular/forms';
import { VolvoApiService } from '../../../../services/volvo-api.service';
import { FormControlService } from '../../../../services/form-control.service';
import { MatDialogRef } from '@angular/material';
import { PageConfiguration } from '../../../../models/page-configuration';

@Component({
  selector: 'app-share',
  templateUrl: './share.component.html',
  styleUrls: ['./share.component.scss']
})
export class ShareComponent implements OnInit {

  @Input() pageConfig: PageConfiguration;
  @Input() localStrings: Observable<Array<any>>;

  public shareForm: FormGroup;
  private shareFormfields: any;
  private referringPtoUrl: string;

  public errorMessages: Array<any>;
  public formSubmitAttempt: boolean;
  public submitSuccess = false;

  constructor(
    private volvoApi: VolvoApiService,
    private _fs: FormControlService,
    private dialogRef: MatDialogRef<ShareComponent>
  ) { }

  ngOnInit() {
    const shareformData = this.volvoApi.XMLObjectFromString(this.pageConfig.ShareForm);
    this.shareFormfields = this._fs.generateFormRows(shareformData, false);
    this.shareForm = this._fs.toFormGroup(this.shareFormfields);
  }

  onSubmit() {
    if (this.shareForm.valid) {
      const formValues = this.shareForm.value;
      formValues['referringPtoUrl'] = window.location.href;
      const formData = JSON.stringify(formValues);

      this.volvoApi.saveBizForm(formData, 'SaveSpreadTheWord')
        .subscribe(r => {
          if (r.Success) {
            
            this.formSubmitAttempt = false;
            this.submitSuccess = true;
            setTimeout(() => {
              this.dialogRef.close();
            }, 7500);
          } else {
            this.errorMessages = r.errorMessages;
          }
        });
    }
  }

  clickSubmit() {
    if (this._fs.validateForm(this.shareForm)) { this.onSubmit(); }
  }

}
